export const SCREEN_NAME = {
    CHECKOUT: "checkout",
    CUSTOMIZATION: "customization",
    COUPON_LISTING: "food-apply-coupon",
    GROUP_CART: "group-cart",
    GIFTING_APPLY_COUPON: "gifting-apply-coupon",
    GIFTING_CHECKOUT: "gifting-checkout",
};
